import StepWrapper from "@/components/steps/StepWrapper";

const InfoStep = ({ step }) => {
  const renderContent = () => {
    switch (step.content) {
      case "productIntro":
        return (
          <>
            <img
              src={`${window.template_root}/src/public/img/bottle.avif`}
              alt="Naori Bottle"
              fetchPriority="high"
              loading="eager"
              className="max-w-full h-auto mx-auto block pb-4 md:pb-4"
            />
            <p className="text-[0.95rem] md:text-base leading-[1.3] md:leading-[1.6] text-center">
              With Naori, you get natural ingredients already present in your
              gut, ready to help you restore your well-being:
            </p>

            <ul className="list-none flex flex-col gap-2.5 md:gap-2.5 mt-2.5 md:mt-3">
              <li className="flex items-center gap-2 md:gap-4 rounded-[14px] md:rounded-[18px] p-2.5 md:p-4 bg-white">
                <img
                  src={`${window.template_root}/src/public/img/illustrations/probiotic-strains.avif`}
                  alt="Probiotic Strains"
                  fetchPriority="high"
                  loading="eager"
                  className="w-[54px] md:w-[66px] h-[54px] md:h-[66px] shrink-0"
                />
                <div className="flex flex-col gap-0 md:gap-0.5">
                  <span className="text-[0.9rem] md:text-base font-semibold text-green">
                    Probiotic strains
                  </span>
                  <span className="text-[0.9rem] md:text-[0.9rem] text-gray leading-[1.4]">
                    Good bacteria that help keep your gut healthy and balanced.
                  </span>
                </div>
              </li>

              <li className="flex items-center gap-2 md:gap-4 rounded-[14px] md:rounded-[18px] p-2.5 md:p-4 bg-white">
                <img
                  src={`${window.template_root}/src/public/img/illustrations/prebiotic-fibers.avif`}
                  alt="Prebiotic Fibers"
                  fetchPriority="high"
                  loading="eager"
                  className="w-[54px] md:w-[66px] h-[54px] md:h-[66px] shrink-0"
                />
                <div className="flex flex-col gap-0 md:gap-0.5">
                  <span className="text-[0.9rem] md:text-base font-semibold text-green">
                    Prebiotic fibers
                  </span>
                  <span className="text-[0.9rem] md:text-[0.9rem] text-gray leading-[1.4]">
                    Plant-based nutrients that feed your good gut bacteria so
                    they thrive.
                  </span>
                </div>
              </li>

              <li className="flex items-center gap-2 md:gap-4 rounded-[14px] md:rounded-[18px] p-2.5 md:p-4 bg-white">
                <img
                  src={`${window.template_root}/src/public/img/illustrations/postbiotic-enzymes.avif`}
                  alt="Postbiotic Enzymes"
                  fetchPriority="high"
                  loading="eager"
                  className="w-[54px] md:w-[66px] h-[54px] md:h-[66px] shrink-0"
                />
                <div className="flex flex-col gap-0 md:gap-0.5">
                  <span className="text-[0.9rem] md:text-base font-semibold text-green">
                    Postbiotic enzymes
                  </span>
                  <span className="text-[0.9rem] md:text-[0.9rem] text-gray leading-[1.4]">
                    Compounds made by good bacteria to support digestion and
                    immunity.
                  </span>
                </div>
              </li>
            </ul>
          </>
        );

      default:
        return <p>Content not found: {step.content}</p>;
    }
  };

  return (
    <StepWrapper title={step.title} subtitle={step.subtitle}>
      {renderContent()}
    </StepWrapper>
  );
};

export default InfoStep;
